import { useCallback, useEffect, useState } from 'react';
import { useFetch } from 'hooks';
import { getHandleInfo } from '../actions/getHandleInfo';
import { contactFromUserHandleInfo } from '../types';
const EMPTY = [];
export const useOnSearch = () => {
    const [searchFilter, setSearchFilter] = useState('');
    const [fetchHandleInfo, isLoading] = useFetch();
    const [remoteContacts, setRemoteContacts] = useState(EMPTY);
    useEffect(() => {
        if (searchFilter.length > 1) {
            const handle = (searchFilter.startsWith('@') ? searchFilter.substring(1) : searchFilter).toLowerCase();
            fetchHandleInfo(getHandleInfo(handle))
                .then((it) => {
                const contact = contactFromUserHandleInfo({ ...it, handle });
                setRemoteContacts(contact ? [contact] : EMPTY);
            })
                .catch(() => setRemoteContacts(EMPTY));
        }
        else
            setRemoteContacts([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchFilter]);
    const handleSearch = useCallback((text) => {
        setSearchFilter(text.replace(/[`~!#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, ' '));
    }, []);
    const handleReset = useCallback(() => {
        setSearchFilter('');
    }, []);
    return { searchFilter, handleSearch, handleReset, remoteContacts, isLoading };
};
